export enum ChargeToCdAbbrValue {
  both = 'BTH',
  collect = 'COL',
  prepaid = 'PPD',
}
